export default __webpack_public_path__ + "static/coll-sexual-health__sexual-health-free-01-fc3ba7738a84c5ba78d6d126cf427b0e.jpg";